module.exports = __webpack_public_path__ + "908c65653eba05294a36b96dbe9a8ff8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg45.jpeg
// module id = 56
// module chunks = 0